// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fec10ab5","455":"3f93356b","977":"571d84fc"}[chunkId] + ".chunk.js";
};